import moment from "moment";

export const AUTH_STORAGE_KEY = 'sgt_auth';
export const USER_STORAGE_KEY = 'sgt_user';

export const getStorageData = (key: string) => {
  return window.localStorage.getItem(key)
    ? JSON.parse(window.localStorage.getItem(key) || "{}")
    : JSON.parse(window.sessionStorage.getItem(key) || "{}");
};

export const removeStorageData = (key: string) => {
  window.localStorage.getItem(key) && window.localStorage.removeItem(key);
  window.sessionStorage.getItem(key) && window.sessionStorage.removeItem(key);
};

export const saveStorageData = (key: string, data: {[k: string]: any}) => {
  const storageObj = JSON.stringify(data) || "{}";
  localStorage.setItem(key, storageObj);
  sessionStorage.setItem(key, storageObj);
};

/**
 *
 * @param data
 * @param scrollToFirstError
 * Scroll to first error if scrollToFirstError = true
 * formData keys should be the same as the id of the form fields
 */
export function notValidForm<T extends {[k: string]: any}>(data: T, scrollToFirstError = false) {
  const invalidFields = Object.entries(data).filter(([key, value]) => !value?.checkValidity());

  if (!!invalidFields?.length && scrollToFirstError) {
    const firstInvalidKey = invalidFields?.[0]?.[0];
    const firstInvalidInput = document.querySelector(`#${firstInvalidKey}`);
    firstInvalidInput?.scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "start"
    });
  }

  return invalidFields.length > 0;
}

export const uid = function () {
  return Date.now().toString(36) + Math.random().toString(36).substr(2);
};

export const getName = (object: {[key: string]: any} | undefined | null) => {
  if (!object) return "";
  return object?.name || `${object?.first_name} ${object?.last_name}`;
};

export function toCapitalize(value: string = "") {
  return value.charAt(0).toUpperCase() + value.slice(1);
}

export function sortByKey<T>(arr: T[], key: keyof T): T[] {
  if (typeof key !== "string") {
    console.error("sortByKey: key is wrong");
    return arr;
  }
  return arr.sort((a, b) => {
    return String(a[key]).localeCompare(String(b[key]));
  });
}

const now = moment();

/**
 * timestamp => 1:15 PM
 */
export const formatCreatedAt = (timestamp: number, withTime: boolean = false) => {
  const createdAt = moment.unix(timestamp);
  const isToday = createdAt.isSame(now, 'day');
  return isToday
    ? createdAt.format("LT")
    : (
      withTime 
        ? createdAt.format("MMM D LT")
        : createdAt.format("MMM D")
    );
}

/**
 * YYYY-MM-DD => MM/DD/YY
 */
export const formatDate = (value: string) => {
  if (!value) return '';
  return moment(value).format('MM/DD/YY');
}

/**
 * seconds => minutes seconds
 */
export const formatDuration = (value: number) => {
  if (!value) return '-';
  const minutes = Math.floor(value / 60);
  const seconds = value % 60;
  return `${minutes}mins ${seconds}seconds`;
}

